import FormField from "../../../shared/components/FormField";
import SocialAuthButtons from "./SocialAuthButtons";
import { useLogin } from "../hooks/useLogin";

export default function LoginForm({ onOtp, onForgotPassword, onSuccess }) {
    const { fields, set, fieldErrors, loading, error, handleSubmit } = useLogin({
        onOtpRequired: onOtp,
        onSuccess,
    });

    return (
        <form className="ogm-auth-form" onSubmit={handleSubmit} noValidate>
            <FormField
                type="email"
                placeholder="Email address"
                value={fields.email}
                onChange={set("email")}
                error={fieldErrors.email}
                required
            />

            <FormField
                type="password"
                placeholder="Password"
                value={fields.password}
                onChange={set("password")}
                error={fieldErrors.password}
                required
            />

            {error && (
                <p className="ogm-auth-error" role="alert">
                    {error}
                </p>
            )}

            <div className="ogm-auth-actions">
                <span className="ogm-link" onClick={onOtp} role="button" tabIndex={0}>
                    Login with OTP
                </span>
                <span className="ogm-link" onClick={onForgotPassword} role="button" tabIndex={0}>
                    Forgot password?
                </span>
            </div>

            <button className="ogm-primary-btn" disabled={loading} type="submit">
                {loading ? "Logging in…" : "Login"}
            </button>

            <SocialAuthButtons />
        </form>
    );
}
